// Input mask for recovery-code text fields: uppercase, strip everything but
// letters/digits, and insert a dash after every 4 characters so what the user
// types matches the printed XXXX-XXXX-… grouping (recoveryCodeDisplay).
// Purely cosmetic — every consumer still runs normalizeRecoveryCode (which
// strips dashes/spaces) before using the code.

const MAX_CODE_CHARS = 32 // 8 groups of 4

/** Dash-grouped form of any raw input, capped at 32 code characters. */
export function formatRecoveryCodeInput (value) {
  const chars = String(value || '').toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, MAX_CODE_CHARS)
  return chars.replace(/(.{4})(?=.)/g, '$1-')
}

/**
 * @update:model-value handler body for a recovery-code v-text-field: returns
 * the dash-grouped form of `value` and keeps the caret anchored to the same
 * code character in the focused input even when a dash lands in front of it.
 * (Plain v-model + a watcher would throw the caret to the end on mid-string
 * edits, and Vue skips its DOM patch entirely when a stripped character
 * leaves the stored value unchanged — hence the direct element sync here.)
 */
export function maskRecoveryCodeField (value) {
  const formatted = formatRecoveryCodeInput(value)
  const el = document.activeElement
  if (el && el.tagName === 'INPUT' && typeof el.selectionStart === 'number') {
    const codeCharsBeforeCaret = countCodeChars(el.value.slice(0, el.selectionStart))
    if (el.value !== formatted) el.value = formatted
    const pos = caretIndexAfter(formatted, codeCharsBeforeCaret)
    el.setSelectionRange(pos, pos)
  }
  return formatted
}

function countCodeChars (str) {
  return str.replace(/[^0-9A-Za-z]/g, '').length
}

function caretIndexAfter (formatted, codeChars) {
  if (codeChars <= 0) return 0
  let seen = 0
  for (let i = 0; i < formatted.length; i++) {
    if (formatted[i] !== '-' && ++seen === codeChars) return i + 1
  }
  return formatted.length
}
